(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    new Splide('#testimonialSplide', {
      type   : 'loop',
      perPage: 4,
      arrows: false,
      gap: '20px',
      autoplay: false,
      pagination: false,
      breakpoints: {
        1024: { perPage: 2 },
        768: { perPage: 1, gap: '17px', focus: 'center' }
      }
    }).mount();
  });

  } catch(e) { console.error(e); }
})();
})();
